import React, {useEffect} from 'react';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import moment from "moment/moment";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import firebase from "../../firebase/firebase";
import MenuItem from "@mui/material/MenuItem";
import {Select} from "@mui/material";
import InputBase from '@mui/material/InputBase';
import {useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";

export default function LiveProject(){
  const [workStatus, setWorkStatus] = React.useState("")
  const navigator = useNavigate()
  const [projects, setProjects] = React.useState([]);
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: 'none',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  const [filterData, setFilterData] = React.useState([])
  const [searchValue, setSearchValue] = React.useState('')
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: '#F1F4F8',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
  const [spv, setSpv] = React.useState()

  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
      marginTop: theme.spacing(3),
    },
    '& .MuiInputBase-input': {
      borderRadius: 30,
      position: 'relative',
      backgroundColor: '#204488',
      border: 'none',
      fontSize: 16,
      width: 150,
      color: '#fff',
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      '&:focus': {
        borderRadius: 30,
        borderColor: 'none',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
    },
  }));
  
  const search = () => {
     
    if (searchValue === '') {
      setFilterData([...projects])
    } else {
      const regex = new RegExp(searchValue.toLowerCase());
      setFilterData(projects.filter((u) => regex?.test(u.title.toLowerCase()) || regex?.test(u.creatorName.toLowerCase()) ));
    }
  }

  useEffect(() => {
    let projectRef = firebase
      .firestore()
      .collection('projects')
      .orderBy('createdAt', 'desc')
      .where('status', '==', 'approved')
      .get()
      .then((snapshots) => {
        setFilterData(snapshots?.size > 0 ? snapshots.docs.map((project) => ({id: project?.id, ...project.data(), dropdown: false})) : [])
        setProjects(snapshots?.size > 0 ? snapshots.docs.map((project) => ({id: project?.id, ...project.data(), dropdown: false})) : [])
      })

  }, [])
  return (
    <Container maxWidth={'full-width'}  sx={{height: 'calc(100vh - 120px)', p: 5, textAlign: 'left', overflowY: 'scroll'}}>
      {spv ?
        <Stack direction={'column'}
               justifyContent="center"
               alignItems="flex-start" spacing={5}>
          <Typography variant={'h4'} color={'primary'}>
            SPV details
          </Typography>
          <Stack direction={'column'} spacing={3}  justifyContent="flex-start"
                 alignItems="flex-start">
            <Stack direction={'row'} spacing={5} sx={{width: '100%'}}>
              <Typography variant={'body2'} color={'secondary'} sx={{width: 150}}>SPV name</Typography>
              <Typography variant={'body2'} color={'secondary'}>{spv?.spvName}</Typography>
            </Stack>
            <Stack direction={'row'} spacing={5} sx={{width: '100%'}}>
              <Typography variant={'body2'} color={'secondary'} sx={{width: 150}}>SPV country</Typography>
              <Typography variant={'body2'} color={'secondary'} >{spv?.spvCountry}</Typography>
            </Stack>
            <Typography variant={'body2'} color={'secondary'} >
              Members
            </Typography>
            {spv?.peoples && spv?.peoples.length > 0 && spv?.peoples.map((member) =>  <>

              <Stack direction={'row'} spacing={5} sx={{width: '100%'}}>
                <Typography variant={'body2'} color={'secondary'} sx={{width: 150}}>Name</Typography>
                <Typography variant={'body2'} color={'secondary'} >{member?.name}</Typography>
              </Stack>
              <Stack direction={'row'} spacing={5} sx={{width: '100%'}}>
                <Typography variant={'body2'} color={'secondary'} sx={{width: 150}}>Email</Typography>
                <Typography variant={'body2'} color={'secondary'} >{member?.email}</Typography>
              </Stack>
            </>)}
            <Typography variant={'body2'} color={'secondary'}>
              Companies
            </Typography>
            {spv?.companies && spv?.companies.length > 0 && spv?.companies.map((member) =>  <>

              <Stack direction={'row'} spacing={5} sx={{width: '100%'}}>
                <Typography variant={'body2'} color={'secondary'} sx={{width: 150}}>Company name</Typography>
                <Typography variant={'body2'} color={'secondary'} >{member?.companyName}</Typography>
              </Stack>
              <Stack direction={'row'} spacing={5} sx={{width: '100%'}}>
                <Typography variant={'body2'} color={'secondary'} sx={{width: 150}}>Company email</Typography>
                <Typography variant={'body2'} color={'secondary'} >{member?.email}</Typography>
              </Stack>
              <Stack direction={'row'} spacing={5} sx={{width: '100%'}}>
                <Typography variant={'body2'} color={'secondary'} sx={{width: 150}}>Address address</Typography>
                <Typography variant={'body2'} color={'secondary'} >{member?.address}</Typography>
              </Stack>
            </>)}

          </Stack>
          <Stack direction={'row'} spacing={5} sx={{width: '100%'}} justifyContent="center"
                 alignItems="center">
            <Button variant={'contained'} onClick={() => setSpv(null)}>Go back</Button>
          </Stack>
        </Stack> :
        <Stack direction={'column'} spacing={5}>
          <Stack direction={'row'} spacing={3}>
            <Typography variant={'h4'} color={'primary'}>
              Live projects
            </Typography>
            <Box sx={{flex: 1}}/>
            <Stack direction='row'  justifyContent="center"
                   alignItems="center">
              <TextField value={searchValue}
               onChange={(e) => setSearchValue(e.target.value)}
               onKeyDown={(e) => {
    if (e.code === "Enter") {
      search()
    }
  }}
                 sx={{width:'90%', textAlign:'left', outline:'none'}} size={"small"}/>
              <Button variant={'contained'} sx={{ borderRadius: 0, boxShadow:'none', py: 1.15}} size={"small"} onClick={search}><SearchIcon/></Button>
            </Stack>
          </Stack>

          <TableContainer >
            <Table sx={{ minWidth: 700 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <StyledTableCell sx={{fontWeight: 'bolder', fontSize:16,width:"20px" }}>Project name</StyledTableCell>
                  <StyledTableCell  align="center"  sx={{fontWeight: 'bolder', fontSize:16, }}>Creator</StyledTableCell>
                  <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Profile</StyledTableCell>
                  <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Posted as</StyledTableCell>
                  <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Project status</StyledTableCell>
                  <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Approvals</StyledTableCell>
                  <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Project management</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filterData.length > 0
                  && filterData.map((row, i) => (
                    <StyledTableRow
                      key={row.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <StyledTableCell  component="th"  
                      scope="row">
                       <Typography component="div">
                      <Box  style={{width:"250px"}} noWrap={true}><Button variant={'text'} color={'primary'} sx={{textDecoration: 'underline'}} onClick={() => navigator(`/admin/pending-project-details/${row?.id}`)}>{row?.title}</Button></Box>
                      </Typography>
                      </StyledTableCell>

                      <StyledTableCell   align="center">
                        <Typography noWrap={true} >
                          {row?.creatorName || row?.uid}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="center"><Button variant={'text'} color={'primary'} sx={{textDecoration: 'underline'}} onClick={() => navigator('/admin/user-details/' + row?.uid)}>View</Button></StyledTableCell>
                      <StyledTableCell align="center">
                      <Typography>{row?.organizationType === 'SPV' ? <Button variant={'text'}   color={'primary'} sx={{textDecoration: 'underline'}} onClick={() =>setSpv(row?.spvProject)}>{row?.organizationType}</Button> : row?.organizationType}</Typography></StyledTableCell>
                      <StyledTableCell align="center">

                        <Select value={row?.workingStatus ? row?.workingStatus :'pending'} multiple={false} 
                        style={{color:"white",borderRadius:"30px",backgroundColor:"#204488",paddingLeft:"10px",paddingRight:"10px",width:"200px",height:"45px"}}
                        IconComponent={() => <ArrowDropDownIcon  />}
                         onChange={(e) => {
                          const p = [...projects];
                          p[i].workingStatus = e.target.value
                          setProjects(p)
                          setFilterData(p)
                          firebase
                            .firestore()
                            .collection('projects')
                            .doc(row?.id)
                            .update({workingStatus: e.target.value})
                            .then()

                        }}>
                          <MenuItem value={'pending'}>
                            Yet to start
                          </MenuItem>
                          <MenuItem value={'development'}>
                            In development
                          </MenuItem>
                          <MenuItem value={'close'}>
                            Close
                          </MenuItem>
                        </Select>
                        {/*<Button variant={'contained'} sx={{px: 3, textTransform: 'capitalize'}} endIcon={<ArrowDropDownIcon/>}>{row.status || 'pending'}</Button>*/}



                      </StyledTableCell>

                      <StyledTableCell align="center"><Typography noWrap={true}>{row?.status}</Typography></StyledTableCell>
                      <StyledTableCell align="center"><Button variant={'text'} sx={{textDecoration: 'underline'}} onClick={() => navigator('/admin/project-management', {state: {project: row}})}>View project</Button></StyledTableCell>

                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

        </Stack>}
    </Container>
  )
}